export const createWorkspaceSlice = (set) => ({
    workspace: null,
    geoLocation: null,
    doctorDisplayByDoctorId: {},
    workspaceLoading: true,
    workspaceError: null,
    visibleDoctorIds: null,
    retryLoad: null,
    pricingRefreshPending: false,
    setPricingRefreshPending: (pending) => set({ pricingRefreshPending: pending }),
    setWorkspace: (workspace) => set({ workspace }),
    setGeoLocation: (geo) => set({ geoLocation: geo }),
    setDoctorDisplayMap: (map) => set({ doctorDisplayByDoctorId: map }),
    setWorkspaceLoading: (v) => set({ workspaceLoading: v }),
    setWorkspaceError: (msg) => set({ workspaceError: msg }),
    setVisibleDoctorIds: (ids) => set({ visibleDoctorIds: ids }),
    setRetryLoad: (fn) => set({ retryLoad: fn }),
});
